import   AttachmentTypeEnum                 from './AttachmentTypeEnum';
import { IAttachment }                      from '.';


/**
 * Define attachment entity associated URL type.
 */
export class AttachmentUrlEntity implements IAttachment {
    public attId!: string;
    public type!: AttachmentTypeEnum;
    public target!: string;

    /**
     * Constructor
     * 
     * @param id - The associated button unique id
     * @param url - The associated url
     * @param text - The link text
     * @param linkCSS - The list of CSS classes to set to the link component
     */
    constructor(private id: string,
                public  url: string,
                public  text: string,
                public  linkCSS?: string) {

                    this.type = AttachmentTypeEnum.URL;
                    this.attId = `url-${this.id}`;
                    this.target = url.startsWith("javascript:") ? "" : "_blank";
                }
}
